module.exports = __webpack_public_path__ + "img/SinnohPreview.0f771c72.png";